<template>
    <div class="flex flex-col">
        <div class="bg-white shadow overflow-hidden sm:rounded-lg mb-5">
            <div class="grid grid-cols-6 px-4 py-5 sm:px-6 place-items-center">
                <div class="col-span-2 justify-self-start">
                    <div class="align-middle">
                        <h3 class="text-lg leading-6 font-medium text-gray-900">
                            {{ title }}
                        </h3>
                    </div>
                </div>

                <div class="col-span-4 justify-self-end" v-if="hasbuttons">
                    <template v-for="button in buttons">
                        <a :href="button.link" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-uknar-primary text-base font-medium text-white hover:bg-uknar-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-uknar-primary sm:ml-3 sm:w-auto sm:text-sm">
                            {{ button.text }}
                        </a>
                    </template>
                    <a v-if="isexportable" :href="exportUrl" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-uknar-primary text-base font-medium text-white hover:bg-uknar-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-uknar-primary sm:ml-3 sm:w-auto sm:text-sm">
                        Download
                    </a>
                </div>
            </div>
        </div>
        <div class="mb-5 flex justify-end" v-if="issearchable">
            <div class="inline-flex">
                <Datepicker v-if="hasdatepicker" v-model="date" range autoApply placeholder="Date range" class="sm:text-sm placeholder-gray-500 text-gray-900 mr-3 w-full"></Datepicker>
                <input type="text" v-model="search_query" placeholder="Search" class="appearance-none shadow-sm rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-uknar-primary focus:border-uknar-primary focus:z-10 sm:text-sm"/>
                <button v-on:click="search()"  class="ml-3 inline-flex justify-center py-2 px-4 border border-uknar-primary-dark shadow-sm text-sm font-medium rounded-md text-white bg-uknar-primary hover:bg-uknar-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-uknar-primary">
                    Search
                </button>
            </div>
        </div>
        <div class="-my-2 sm:-mx-6 lg:-mx-8">
            <div class="py-2 align-middle inline-block sm:px-6 lg:px-8 w-full">

              <div class = "overflow-x-auto sm:rounded-lg">
                <div class="shadow border-b border-gray-200" v-if="!isLoading && items.length > 0">
                    <table class="min-w-full divide-y divide-gray-200">
                        <thead class="bg-gray-50">
                        <tr>
                            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" v-for="item in items[0]">
                                <span v-if="item.key && isorderable" class="cursor-pointer flex justify-between" v-on:click="sort(item.key)">
                                    {{ item.name }}
                                    <span v-if="item.key == orderValue && orderClicks === 1" class="flex items-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                          <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                                        </svg>
                                    </span>
                                    <span v-else-if="item.key == orderValue && orderClicks === 2" class="flex items-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                          <path stroke-linecap="round" stroke-linejoin="round" d="M5 15l7-7 7 7" />
                                        </svg>
                                    </span>
                                </span>
                                <span v-else>
                                    {{ item.name }}
                                </span>
                            </th>
                        </tr>
                        </thead>
                        <tbody :key="key" class="bg-white divide-y divide-gray-200">
                            <tr v-for="row in items">
                                <td class="px-6 py-4 whitespace-nowrap" v-for="column in row">
                                    <div class="flex items-center" v-if="column.type == 'string'">
                                        <div class="text-sm text-gray-900">
                                            {{ column.value }}
                                        </div>
                                    </div>
                                    <div class="flex items-center" v-else-if="column.type == 'number'">
                                        <div class="text-sm font-medium text-gray-900 text-center">
                                            {{ column.value }}
                                        </div>
                                    </div>
                                    <div class="flex items-center" v-else-if="column.type == 'state'">
                                        <span :class="getStateColour(column.state)" class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full">
                                            {{ column.value }}
                                        </span>
                                    </div>
                                    <div class="flex items-center whitespace-nowrap text-right text-sm font-medium space-x-4" v-else-if="column.type == 'action'">
                                        <span v-for="action in column.actions">
                                            <a v-if="action.type && action.type == 'deleteModal'" v-on:click="this.$parent.openDeleteModal(action.href, action.name)" :class="getActionColour(action.color)" class="font-medium cursor-pointer">{{ action.name }}</a>
                                            <a v-else :href="action.href" :class="getActionColour(action.color)" class="font-medium">{{ action.name }}</a>
                                        </span>
                                    </div>
                                    <div class="flex items-center whitespace-nowrap text-right text-sm font-medium space-x-4" v-else-if="column.type == 'slot'">
                                        <slot :name="column.slot_name" :item="column"></slot>
                                    </div>
                                    <template v-if="column.additional_data?.length"
                                              v-for="line of column.additional_data">
                                        <div class="flex items-center text-xs font-medium text-gray-500">{{ line }}</div>
                                    </template>
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </div>

                <div class="shadow border-b border-gray-200" v-else-if="isLoading">
                    <table class="min-w-full divide-y divide-gray-200">
                        <thead class="bg-gray-50">
                            <tr class="animate-pulse">
                                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    <p class="w-24 bg-gray-300 h-6 rounded-md">
                                    </p>
                                </th>
                                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    <p class="w-24 bg-gray-300 h-6 rounded-md">
                                    </p>
                                </th>
                                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    <p class="w-24 bg-gray-300 h-6 rounded-md">
                                    </p>
                                </th>
                            </tr>
                        </thead>
                        <tbody class="bg-white divide-y divide-gray-200">

                            <tr class="animate-pulse">
                                <td class="px-6 py-4 whitespace-nowrap">
                                    <div class="text-sm font-medium text-gray-900">
                                        <p class="w-12 bg-gray-300 h-6 rounded-md">
                                        </p>
                                    </div>
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap">
                                    <div class="text-sm text-gray-900">
                                        <p class="w-12 bg-gray-300 h-6 rounded-md">
                                        </p>
                                    </div>
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap">
                                    <div class="text-sm text-gray-900">
                                        <p class="w-12 bg-gray-300 h-6 rounded-md">
                                        </p>
                                    </div>
                                </td>
                            </tr>

                            <tr class="animate-pulse">
                                <td class="px-6 py-4 whitespace-nowrap">
                                    <div class="text-sm font-medium text-gray-900">
                                        <p class="w-12 bg-gray-300 h-6 rounded-md">
                                        </p>
                                    </div>
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap">
                                    <div class="text-sm text-gray-900">
                                        <p class="w-12 bg-gray-300 h-6 rounded-md">
                                        </p>
                                    </div>
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap">
                                    <div class="text-sm text-gray-900">
                                        <p class="w-12 bg-gray-300 h-6 rounded-md">
                                        </p>
                                    </div>
                                </td>
                            </tr>

                            <tr class="animate-pulse">
                                <td class="px-6 py-4 whitespace-nowrap">
                                    <div class="text-sm font-medium text-gray-900">
                                        <p class="w-12 bg-gray-300 h-6 rounded-md">
                                        </p>
                                    </div>
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap">
                                    <div class="text-sm text-gray-900">
                                        <p class="w-12 bg-gray-300 h-6 rounded-md">
                                        </p>
                                    </div>
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap">
                                    <div class="text-sm text-gray-900">
                                        <p class="w-12 bg-gray-300 h-6 rounded-md">
                                        </p>
                                    </div>
                                </td>
                            </tr>

                            <tr class="animate-pulse">
                                <td class="px-6 py-4 whitespace-nowrap">
                                    <div class="text-sm font-medium text-gray-900">
                                        <p class="w-12 bg-gray-300 h-6 rounded-md">
                                        </p>
                                    </div>
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap">
                                    <div class="text-sm text-gray-900">
                                        <p class="w-12 bg-gray-300 h-6 rounded-md">
                                        </p>
                                    </div>
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap">
                                    <div class="text-sm text-gray-900">
                                        <p class="w-12 bg-gray-300 h-6 rounded-md">
                                        </p>
                                    </div>
                                </td>
                            </tr>

                            <tr class="animate-pulse">
                                <td class="px-6 py-4 whitespace-nowrap">
                                    <div class="text-sm font-medium text-gray-900">
                                        <p class="w-12 bg-gray-300 h-6 rounded-md">
                                        </p>
                                    </div>
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap">
                                    <div class="text-sm text-gray-900">
                                        <p class="w-12 bg-gray-300 h-6 rounded-md">
                                        </p>
                                    </div>
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap">
                                    <div class="text-sm text-gray-900">
                                        <p class="w-12 bg-gray-300 h-6 rounded-md">
                                        </p>
                                    </div>
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </div>

                <div class="overflow-hidden shadow rounded-lg" v-else>
                    <div class="bg-gray-50 px-4 py-5 sm:p-6 text-center">
                        <p>There are no {{ title.toLowerCase() }} available!</p>
                    </div>
                </div>
              </div>
                <nav class="py-3 flex items-center justify-between sm:px-6" aria-label="Pagination" v-if="items.length > 0">
                    <div class="hidden sm:block">
                      <p class="text-sm text-gray-700">
                        Showing
                        {{ ' ' }}
                        <span class="font-medium">{{ meta.from }}</span>
                        {{ ' ' }}
                        to
                        {{ ' ' }}
                        <span class="font-medium">{{ meta.to }}</span>
                        {{ ' ' }}
                        of
                        {{ ' ' }}
                        <span class="font-medium">{{ meta.total }}</span>
                        {{ ' ' }}
                        results
                      </p>
                    </div>
                    <div class="relative z-0 inline-flex shadow-sm rounded-md" v-if="links.prev || links.next">
                      <a v-if="links.prev" @click="loadNewData(links.prev)" class="cursor-pointer w-24 text-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500">
                        Previous
                      </a>
                      <a v-else class="cursor-not-allowed w-24 text-center px-2 py-2 rounded-l-md border border-gray-300 bg-gray-300 text-sm font-medium text-gray-500 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500">
                        Previous
                      </a>
                      <a v-if="links.next" @click="loadNewData(links.next)" class="cursor-pointer w-24 text-center -ml-px px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500">
                        Next
                      </a>
                      <a v-else class="cursor-not-allowed w-24 text-center -ml-px px-2 py-2 rounded-r-md border border-gray-300 bg-gray-300 text-sm font-medium text-gray-500 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500">
                        Next
                      </a>
                    </div>
                  </nav>
            </div>
        </div>
    </div>
    <div class="hidden border-amber-500 bg-amber-500 hover:bg-amber-600 border-green-500 bg-green-500 hover:bg-green-600 border-rose-500 bg-rose-500 hover:bg-rose-600"></div>
</template>

<script>
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import {DateTime} from "luxon";
export default {
    components: { Datepicker },
    props: {
        title: {
            type: String,
            required: true
        },
        endpoint: {
            type: String,
            required: true
        },
        hasbuttons: {
            type: Boolean,
            default: false
        },
        buttons: {
            type: Object
        },
        issearchable: {
            type: String
        },
        isexportable: {
            type: Boolean,
            default: false
        },
        hasdatepicker: {
            type: String
        },
        isorderable: {
            type: String
        }
    },

    computed: {
        exportUrl() {
            if (!this.url) {
                return '#';
            }

            let urlObj = new URL(this.url);
            urlObj.searchParams.set('export', '1');
            return urlObj.toString();
        }
    },

    data: function () {
        return {
            items: false,
            isLoading: true,
            meta: null,
            links: null,
            columnWidth: null,
            url: null,
            orderValue: null,
            orderDirection: false,
            orderClicks: 0,
            search_query: null,
            date: [],
            key: 1
        }
	  },

    methods: {
        async getData() {
            const self = this;

            var parameters = {}

            if (!self.url) {
                self.url = self.endpoint;
            }

            if (self.orderValue) {
                parameters.order = self.orderValue;
                parameters.order_direction = self.orderDirection ? 'ASC' : 'DESC';
            }

            if (self.search_query && self.search_query.length > 0) {
                parameters.search = self.search_query;
            }

            if (self.date?.length > 1) {
                parameters.from = DateTime.fromJSDate(self.date[0]).toISODate();
                parameters.to = DateTime.fromJSDate(self.date[1]).toISODate();
            }

            let url = new URL(self.url);
            for (const param in parameters) {
                url.searchParams.set(param, parameters[param]);
            }

            this.url = self.url = url.toString();
            window.axios.get(this.url)
                .then(response => {
                    self.items = response.data.data;
                    self.meta = response.data.meta;
                    self.links = response.data.links;
                    self.isLoading = false;

                    self.key++;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getActionColour: function (type) {
            var classes = '';

            switch(type) {
                case 'primary':
                  classes = 'text-uknar-primary hover:text-uknar-primary';
                  break;
                case 'secondary':
                  classes = 'text-uknar-secondary hover:text-uknar-secondary';
                  break;
                case 'error':
                  classes = 'text-rose-600 hover:text-rose-900';
                  break;
                case 'success':
                  classes = 'text-green-600 hover:text-green-900';
                  break;
                case 'info':
                  classes = 'text-cyan-600 hover:text-cyan-900';
                  break;
            }

            return classes;
        },
        getStateColour: function (state) {
            var classes = '';

            switch(state) {
                case 'primary':
                  classes = 'bg-uknar-primary text-white';
                  break;
                case 'secondary':
                  classes = 'bg-uknar-secondary text-white';
                  break;
                case 'error':
                  classes = 'bg-rose-100 text-rose-800';
                  break;
                case 'warning':
                  classes = 'bg-amber-100 text-amber-800';
                  break;
                case 'success':
                  classes = 'bg-green-100 text-green-800';
                  break;
                case 'info':
                  classes = 'bg-cyan-100 text-cyan-800';
                  break;
                case 'default':
                  classes = 'bg-gray-400 text-gray-800';
                  break;
            }

            return classes;
        },
        loadNewData: function (endpoint) {

            var self = this;

            self.url = endpoint;

            self.getData();

        },
        sort: function (key) {

            if (!key) return;

            this.orderClicks = this.orderClicks + 1;

            // If the order column changes we switch
            if (this.orderValue !== null && this.orderValue !== key) {

                this.orderClicks = 0;
                this.orderDirection = true;
                this.orderValue = key;

                this.getData();

                return;
            }

            // Determining if we're on 3rd click to reset back to default
            if (this.orderClicks == 3) {

                this.orderClicks = 0;
                this.orderDirection = false;
                this.orderValue = null;

                this.getData();

                return;
            }

            this.orderDirection = !this.orderDirection;
            this.orderValue = key;

            this.getData();

        },
        search: function () {
            this.url = this.endpoint;
            this.getData();
        }
    },
    mounted() {
        this.getData();
    }
}

</script>

<style lang="css">
.dp__input_wrap input {
  width: 25rem!important;
}
</style>

